module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-conversation.404a55e2.png";